import { render } from "./ClientAreaView.vue?vue&type=template&id=2facf222&scoped=true"
import script from "./ClientAreaView.vue?vue&type=script&lang=js"
export * from "./ClientAreaView.vue?vue&type=script&lang=js"

import "./ClientAreaView.vue?vue&type=style&index=0&id=2facf222&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2facf222"]])

export default __exports__